<template>
  <div v-if="api_data.Farmer">
    <div class="card rounded-0 card-custom gutter-b">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="card-label">
            <div class="font-weight-bolder">
              {{ $t('Forest Land (Claimed Land)') }}
            </div>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t('Information') }}</span>
          </div>
        </div>
      </div>
      <div class="card-body pt-2">
        <div class="card-body">
          <div class="row"
               v-if="api_data.Farmer.land_forest_claimed_land_acre || api_data.Farmer.land_forest_claimed_land_guntha || api_data.Farmer.land_forest_claim_application_number"
          >
            <div class="col-md-2">
              <label-text
                  v-bind:text="api_data.Farmer.land_forest_claimed_land_acre"
                  v-bind:label="'Acre'"
              ></label-text>
            </div>
            <div class="col-md-2">
              <label-text
                  v-bind:text="api_data.Farmer.land_forest_claimed_land_guntha"
                  v-bind:label="'Guntha'"
              ></label-text>
            </div>
            <div class="col-md-8">
              <label-text
                  v-bind:text="api_data.Farmer.land_forest_claim_application_number"
                  v-bind:label="'Claim Application Number'"
              ></label-text>
            </div>
          </div>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_cultivation'"
              v-bind:head_title="'Forest Cultivation'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_residence'"
              v-bind:head_title="'Residence'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_natural_trees'"
              v-bind:head_title="'Natural Trees'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_grown_trees'"
              v-bind:head_title="'Grown Trees'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_house'"
              v-bind:head_title="'Forest Land House'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_well'"
              v-bind:head_title="'Forest Land Well'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_engine'"
              v-bind:head_title="'Forest Land Engine'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_pala'"
              v-bind:head_title="'Forest Land Pala'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_trench'"
              v-bind:head_title="'Forest Land Trench'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_improvement_projects'"
              v-bind:head_title="'Forest Land Improvement Projects'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_evidence_farmers_record_book'"
              v-bind:head_title="'Forest Land Evidence Book Registration'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_evidence_bunds'"
              v-bind:head_title="'Bunds (Forest Land Evidence Book Registration)'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_evidence_trees'"
              v-bind:head_title="'Trees (Forest Land Evidence Book Registration)'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_evidence_farm_pond'"
              v-bind:head_title="'Pond (Forest Land Evidence Book Registration)'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_evidence_gps_map'"
              v-bind:head_title="'GPS Map (Forest Land Evidence Book Registration)'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <div class="row"
               v-if="api_data.Farmer.land_forest_entitlement_acre || api_data.Farmer.land_forest_entitlement_guntha"
          >
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_forest_entitlement_acre"
                      v-bind:label="'Acre'"
                  ></label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_forest_entitlement_guntha"
                      v-bind:label="'Guntha'"
                  ></label-text>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <question-with-note-and-multi-input
                  :api_data="api_data"
                  v-bind:file_input_name="'land_forest_entitlement'"
                  v-bind:head_title="'Forest Land Entitlement Information'"
                  v-bind:operation_mode="'read'"
              ></question-with-note-and-multi-input>
            </div>
          </div>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_cultivating_land_through_receipt'"
              v-bind:head_title="'Forest Land Received Through Receipt'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_forest_received_through_claim'"
              v-bind:head_title="'Forest Land Received Through Claim'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <div class="row"
               v-if="api_data.Farmer.land_forest_cultivating_land_measured_acre || api_data.Farmer.land_forest_cultivating_land_measured_guntha"
          >
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_forest_cultivating_land_measured_acre"
                      v-bind:label="'Acre'"
                  ></label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_forest_cultivating_land_measured_guntha"
                      v-bind:label="'Guntha'"
                  ></label-text>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <question-with-note-and-multi-input
                  :api_data="api_data"
                  v-bind:file_input_name="'land_forest_cultivating_land_measured'"
                  v-bind:head_title="'Cultivating Land Measurement'"
                  v-bind:operation_mode="'read'"
              ></question-with-note-and-multi-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label-text
                  v-bind:text="api_data.Farmer.land_forest_claimed_east"
                  v-bind:label="'East (Claimed Land)'"
              ></label-text>
            </div>
            <div class="col-md-3">
              <label-text
                  v-bind:text="api_data.Farmer.land_forest_claimed_west"
                  v-bind:label="'West (Claimed Land)'"
              ></label-text>
            </div>
            <div class="col-md-3">
              <label-text
                  v-bind:text="api_data.Farmer.land_forest_claimed_north"
                  v-bind:label="'North (Claimed Land)'"
              ></label-text>
            </div>
            <div class="col-md-3">
              <label-text
                  v-bind:text="api_data.Farmer.land_forest_claimed_south"
                  v-bind:label="'South (Claimed Land)'"
              ></label-text>
            </div>
          </div>
          <short-data-from-json
              :api_data="api_data"
              v-bind:head_title="'Forest Land Nominees Names'"
              v-bind:data_in_json_input="'land_forest_nominees'"
          ></short-data-from-json>
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_revenue_acre"
                      v-bind:label="'Acre'"
                  ></label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_revenue_guntha"
                      v-bind:label="'Guntha'"
                  ></label-text>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <question-with-note-and-multi-input
                  :api_data="api_data"
                  v-bind:file_input_name="'land_revenue'"
                  v-bind:head_title="'Revenue Land'"
                  v-bind:operation_mode="'read'"
              ></question-with-note-and-multi-input>
            </div>
          </div>
          <text-input
              v-bind:form_label="'7-12-8 Number'"
              v-bind:form_class="'form-control-solid input-lg'"
              v-bind:file_input_name="'land_revenue_7_12_8'"
              :api_data="api_data"
              v-bind:operation_mode="'read'"
          ></text-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_revenue_inherited'"
              v-bind:head_title="'Revenue Land Inherited ?'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_revenue_livelihood'"
              v-bind:head_title="'Revenue Land Livelihood ?'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <question-with-note-and-multi-input
              :api_data="api_data"
              v-bind:file_input_name="'land_revenue_irrigation_facility'"
              v-bind:head_title="'Revenue Land Irrigation Facility ?'"
              v-bind:operation_mode="'read'"
          ></question-with-note-and-multi-input>
          <div class="row">
            <div class="col-md-6">
              <text-input
                  v-bind:form_label="'Acre'"
                  v-bind:form_class="'form-control-solid input-lg'"
                  v-bind:file_input_name="'land_revenue_irrigation_acre'"
                  :api_data="api_data"
                  v-bind:operation_mode="'read'"
              ></text-input>
            </div>
            <div class="col-md-6">
              <text-input
                  v-bind:form_label="'Guntha'"
                  v-bind:form_class="'form-control-solid input-lg'"
                  v-bind:file_input_name="'land_revenue_irrigation_guntha'"
                  :api_data="api_data"
                  v-bind:operation_mode="'read'"
              ></text-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_monsoon_acre"
                      v-bind:label="'Acre'"
                  ></label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_monsoon_guntha"
                      v-bind:label="'Guntha'"
                  ></label-text>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <question-with-note-and-multi-input
                  :api_data="api_data"
                  v-bind:file_input_name="'land_monsoon'"
                  v-bind:head_title="'Monsoon Irrigation ?'"
                  v-bind:operation_mode="'read'"
              ></question-with-note-and-multi-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_government_graze_land_acre"
                      v-bind:label="'Acre'"
                  ></label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_government_graze_land_guntha"
                      v-bind:label="'Guntha'"
                  ></label-text>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <question-with-note-and-multi-input
                  :api_data="api_data"
                  v-bind:file_input_name="'land_government_graze_land'"
                  v-bind:head_title="'Government Graze Land (Monsoon) ?'"
                  v-bind:operation_mode="'read'"
              ></question-with-note-and-multi-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_graze_land_acre"
                      v-bind:label="'Acre'"
                  ></label-text>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label-text
                      v-bind:text="api_data.Farmer.land_graze_land_guntha"
                      v-bind:label="'Guntha'"
                  ></label-text>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <question-with-note-and-multi-input
                  :api_data="api_data"
                  v-bind:file_input_name="'land_graze_land'"
                  v-bind:head_title="'Barren Land (Monsoon) ?'"
                  v-bind:operation_mode="'read'"
              ></question-with-note-and-multi-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'show-land-information',
  props: {
    api_data: Object,
  }
}
</script>
